import { Loader2, RefreshCw } from 'lucide-react';

export const AsyncState = ({ loading, error, onRetry }) => <>
  {loading && <div data-testid="astrology-loading" className="py-12 flex justify-center items-center gap-3 text-[#6B6560]" role="status"><Loader2 className="w-5 h-5 animate-spin" /> Preparing your reading…</div>}
  {error && <div role="alert" data-testid="astrology-error" className="my-5 p-4 border border-red-200 bg-red-50 rounded-lg text-red-800 text-sm">
    <p>{error}</p>{onRetry && <button data-testid="astrology-retry" onClick={onRetry} className="mt-3 inline-flex items-center gap-2 underline"><RefreshCw className="w-4 h-4" />Try again</button>}
  </div>}
</>;